import {findAll} from '../../../JavaScript/Utils';

document.addEventListener('DOMContentLoaded', () => {
    const $allAnchorLinks = findAll('a[href*="#"]:not([href="#"]):not([href="#0"])');

    ScrollToHash();

    if ($allAnchorLinks.length) {
        $allAnchorLinks.forEach(($anchor) => {
            $anchor.addEventListener('click', (event) => {
                const hashUrl = event.target.getAttribute('href');
                const lastIndexOfHash = hashUrl.lastIndexOf('#');

                if (lastIndexOfHash === 0) {
                    event.preventDefault();
                    const hashId = hashUrl.substr(0, lastIndexOfHash) + hashUrl.substr(lastIndexOfHash);
                    const $targetElement = document.getElementById(hashId.replace('#', ''));

                    if ($targetElement) {
                        const targetOffsetTop = $targetElement.offsetTop;
                        window.scrollTo(0, targetOffsetTop - 136);
                    }
                }
            });
        });
    }
});

const ScrollToHash = (timeOut = 200) => {
    const urlHashId = location.hash || '';

    if (location.hash.length) {
        const $targetElement = document.getElementById(urlHashId.replace('#', ''));

        if ($targetElement) {
            const targetOffsetTop = $targetElement.offsetTop;

            setTimeout(() => {
                window.scrollTo(0, targetOffsetTop - 136);
            }, timeOut);
        }
    }
};

window.addEventListener('hashchange', ScrollToHash, false);
